module.exports = __webpack_public_path__ + "img/8-Wow.ead46d0.png";